module.exports = __webpack_public_path__ + "static/media/ic_no_doc.7b8285c2.svg";